// Import icons: иконки пунктов — имена из спрайта (design-system/icons/svg
// martyrs и проекта). Те же имена передают шапки страниц (SectionPageTitle icon),
// поэтому пункт меню и шапка его страницы показывают одну иконку.
import { useGlobalMixins } from '@martyrs/src/modules/core/views/mixins/mixins.js'
const { isModuleInstalled } = useGlobalMixins()

// Backoffice navigation configuration
// Заголовки — ключи локалей модуля (backoffice/views/locales). Navigation.vue
// печатает ключ через t() если перевод есть, иначе строку как есть, поэтому
// конфиги хост-проектов с обычными строками продолжают работать.
export const navigationItems = [
  {
    category: 'backoffice.sections.backoffice',
    visible: () => true,
    items: [
      {
        title: 'backoffice.nav.dashboard',
        icon: 'home',
        route: () => '/backoffice',
      },
      {
        title: 'backoffice.nav.organizations',
        icon: 'groups',
        route: () => '/backoffice/organizations',
        visible: () => isModuleInstalled('organizations')
      },
      {
        title: 'backoffice.nav.users',
        icon: 'users',
        route: () => '/backoffice/users',
        visible: () => isModuleInstalled('auth')
      },
      {
        title: 'backoffice.nav.notifications',
        icon: 'notifications',
        route: () => '/backoffice/notifications',
        visible: () => isModuleInstalled('notifications')
      },
    ]
  },
  {
    category: 'backoffice.sections.discover',
    visible: () => true,
    items: [
      {
        title: 'backoffice.nav.products',
        icon: 'products',
        route: () => '/backoffice/products',
        visible: () => isModuleInstalled('products')
      },
      {
        title: 'backoffice.nav.events',
        icon: 'events',
        route: () => '/backoffice/events',
        visible: () => isModuleInstalled('events')
      },
      {
        title: 'backoffice.nav.community',
        icon: 'community',
        route: () => '/backoffice/community',
        visible: () => isModuleInstalled('community')
      },
      {
        title: 'backoffice.nav.spots',
        icon: 'location',
        route: () => '/backoffice/spots',
        visible: () => isModuleInstalled('spots')
      },
      {
        title: 'backoffice.nav.gallery',
        icon: 'gallery',
        route: () => '/backoffice/gallery',
        visible: () => isModuleInstalled('gallery')
      },
    ]
  },
  {
    category: 'backoffice.sections.management',
    visible: () => true,
    items: [
      {
        title: 'backoffice.nav.categories',
        icon: 'price',
        route: () => '/backoffice/categories',
        visible: () => isModuleInstalled('products')
      },
      {
        title: 'backoffice.nav.inventory',
        icon: 'leftovers',
        route: () => '/backoffice/inventory',
        visible: () => isModuleInstalled('inventory')
      },
      {
        title: 'backoffice.nav.rents',
        icon: 'events',
        route: () => '/backoffice/rents',
        visible: () => isModuleInstalled('rents')
      },
    ]
  },
  // Каталоги содержимого продукта. Экраны даёт модуль `analysis` хост-проекта,
  // поэтому раздел появляется только там, где этот модуль установлен.
  {
    category: 'Каталоги',
    visible: () => isModuleInstalled('analysis'),
    items: [
      {
        title: 'Процедуры',
        icon: 'price',
        route: () => '/backoffice/procedures',
      },
      {
        title: 'Средства ухода',
        icon: 'products',
        route: () => '/backoffice/care-products',
      },
      {
        title: 'Правила промптов',
        icon: null,
        route: () => '/backoffice/prompt-rules',
      },
    ]
  },
  {
    category: 'backoffice.sections.sales',
    visible: () => isModuleInstalled('orders'),
    items: [
      {
        title: 'backoffice.nav.orders',
        icon: 'orders',
        route: () => '/backoffice/orders',
      },
      {
        title: 'backoffice.nav.customers',
        icon: 'customers',
        route: () => '/backoffice/customers',
      },
      {
        title: 'backoffice.nav.applications',
        icon: 'applications',
        route: () => '/backoffice/applications',
      },
      // Промо — один пункт: скидки, промокоды, рефералка, награды и удержание
      // живут внутри раздела (хаб и страницы программ).
      {
        title: 'backoffice.nav.promotions',
        icon: 'price',
        route: () => '/backoffice/promotions',
        visible: () => isModuleInstalled('promotions')
      },
      {
        title: 'Reviews',
        icon: 'popular',
        route: () => '/backoffice/reviews',
        visible: () => isModuleInstalled('reviews')
      },
    ]
  },
  {
    category: 'backoffice.sections.general',
    visible: () => true,
    items: [
      {
        title: 'backoffice.nav.payments',
        icon: 'payments',
        route: () => '/backoffice/payments',
        visible: () => isModuleInstalled('payments')
      },
      {
        title: 'backoffice.nav.pages',
        icon: null,
        route: () => '/backoffice/pages',
        visible: () => isModuleInstalled('pages')
      },
      {
        title: 'backoffice.nav.reports',
        icon: null,
        route: () => '/backoffice/reports',
        visible: () => isModuleInstalled('reports')
      }
    ]
  }
]

export default navigationItems
